import { render, staticRenderFns } from "./CacheManager.vue?vue&type=template&id=13c00604&"
import script from "./CacheManager.vue?vue&type=script&lang=js&"
export * from "./CacheManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports